import { render } from "./insManagement.vue?vue&type=template&id=7b46d7cf&scoped=true"
import script from "./insManagement.vue?vue&type=script&lang=js"
export * from "./insManagement.vue?vue&type=script&lang=js"

import "./insManagement.vue?vue&type=style&index=0&id=7b46d7cf&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b46d7cf"]])

export default __exports__